// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"projects_wrapper__hO_sR","divider":"projects_divider__HDI2O","pre":"projects_pre__004n2","title":"projects_title__F7not","projects":"projects_projects__r7S_3"};